export default "__VITE_PUBLIC_ASSET__2511c653__"